import {Alert} from 'src/design/atoms/Alert';
import {Anchor} from 'src/design/atoms/Anchor';
import {List} from 'src/design/atoms/List';
import {Text} from 'src/design/atoms/Text';
import {IconAlertTriangle} from '@tabler/icons-react';
import React from 'react';
import type {ContentValidationOffender} from 'src/app/training/courseContentValidation';

export interface ValidationPanelProps {
  offenders: ContentValidationOffender[];
  onSelectOffender: (invariantId: string) => void;
}

/**
 * Persistent panel naming every content item with a validation error
 * (Wave 0 defect-3's gate, given named-offender UX). Clicking an offender
 * selects it in the outline so the user can fix it in place.
 */
export const ValidationPanel: React.FC<ValidationPanelProps> = ({
  offenders,
  onSelectOffender,
}) => {
  if (offenders.length === 0) {
    return null;
  }

  return (
    <Alert
      color="red"
      icon={<IconAlertTriangle />}
      title={`${offenders.length} item${offenders.length === 1 ? '' : 's'} ${
        offenders.length === 1 ? 'needs' : 'need'
      } attention before saving`}
      data-testid="validation-panel">
      <List size="sm" spacing={4}>
        {offenders.map(offender => (
          <List.Item key={offender.invariantId}>
            <Anchor
              size="sm"
              onClick={() => onSelectOffender(offender.invariantId)}>
              {offender.label}
            </Anchor>
            <Text span size="sm" c="dimmed">
              {' '}
              ({offender.error})
            </Text>
          </List.Item>
        ))}
      </List>
    </Alert>
  );
};
